export const mapInitialValues = (initialValues, currency) => {
  const mappedInitialValues = {
    ...initialValues,
    thumbnail: initialValues?.picture_id ? [initialValues.picture_id] : [],
    images: initialValues?.picture ? [initialValues.picture] : [],
    parent_product_uid: initialValues?.parent_product?.uid || '',
    color_uid: initialValues?.color?.uid || '',
    size_uid: initialValues?.size?.uid || '',
    inventory_uid: initialValues?.inventory?.uid || '',
    price: initialValues?.price || 0,
    currency: initialValues?.currency || currency || '',
  };

  return mappedInitialValues;
};
